import { Headers } from 'bernie-graphql';
import { ContextStore } from 'bernie-plugin-mobx';

export const getTrackingInfoForLogging = (context: ContextStore | undefined): string => {
  const duaid = context?.deviceId;
  const traceId = (context as any)?.traceInfo?.['Trace-ID'];

  return ` DUAID=${duaid} , TraceID=${traceId}`;
};

export const getTrackingInfoForLoggingFromHeaders = (headers: Headers | undefined): string => {
  const duaid = headers?.['Device-User-Agent-ID'];
  const traceId = headers?.['trace-id'];

  return ` DUAID=${duaid} , TraceID=${traceId}`;
};
